 // =================================================================
 // RAÍZ CUADRADA — PHONE CODES LIBRARY
 // Main Exports
 // =================================================================
 
 export * from './types';
 export * from './constants';
 export { PhoneUtils } from './utils';
export { FlagIcon, getFlagComponent, hasFlag, Flags } from './flags';
 
 // Helper para obtener bandera por código ISO
 import { COMMON_PHONE_CODES } from './constants';
 import type { PhoneCode } from './types';
 
 export function getFlagEmoji(countryCode: string): string {
   const country = COMMON_PHONE_CODES.find(c => 
     c.iso2 === countryCode.toUpperCase() || 
     c.iso3 === countryCode.toUpperCase()
   );
   return country?.flag || '🏳️';
 }
 
 // Helper para obtener lista de países ordenada
 export function getSortedCountries(sortBy: 'name' | 'code' | 'dialCode' = 'name'): PhoneCode[] {
   const countries = [...COMMON_PHONE_CODES];
   
   switch (sortBy) {
     case 'name':
       return countries.sort((a, b) => a.country.localeCompare(b.country, 'es'));
     case 'code':
       return countries.sort((a, b) => a.code.localeCompare(b.code));
     case 'dialCode':
       return countries.sort((a, b) => parseInt(a.dialCode) - parseInt(b.dialCode));
     default:
       return countries;
   }
 }
 
 // Función para obtener México primero y luego el resto
 export function getCountriesWithMexicoFirst(): PhoneCode[] {
   const mexico = COMMON_PHONE_CODES.find(c => c.iso2 === 'MX');
   const others = COMMON_PHONE_CODES
     .filter(c => c.iso2 !== 'MX')
     .sort((a, b) => a.country.localeCompare(b.country, 'es'));
   
   return mexico ? [mexico, ...others] : others;
 }